import React from 'react';
import PropTypes from 'prop-types';
import Ripples from 'react-touch-ripple';
import { ParamsClass } from '../../../../../constants/ColorPage';
import {omit} from 'lodash';
import './styles.less';
export default class Ripple extends React.PureComponent {
    render() {
        const { duration, disabled } = this.props;
        const timeout = { enter: duration / 2, exit: duration / 2 };
        const props = omit(this.props, ['timeout', 'duration', 'className', 'onClick', 'waitForEffect']);
        return (
            <Ripples {...props} timeout={timeout} onClick={this.onClick}
                className={`hms-ripple-effect ${disabled ? 'disabled' : ''} ${this.onClick ? 'cursorPointer' : ''} ${this.props.className || ''}`}>{this.props.children}</Ripples>
        )
    }
    onClick = (event) => {
        if(this.props.disabled) return;
        this.clickTimeout = setTimeout(() => {
            const result = this.props.onClick && this.props.onClick(event);
            clearTimeout(this.clickTimeout);
            return result;
        }, this.props.waitForEffect ? this.props.duration/2 : 0)
    }
}
Ripple.propTypes = {
    duration: PropTypes.number,
    color: PropTypes.string,
    onClick: PropTypes.func,
    waitForEffect: PropTypes.bool,
    disabled: PropTypes.bool,
}
Ripple.defaultProps = {
    duration: 1000,
    color: ParamsClass['@primary-color'],
    waitForEffect: false,
    disabled: false,
}